import { inject, PLATFORM_ID, signal } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { StorageService } from '../services/storage.service';
import { isPlatformBrowser } from '@angular/common';

export const logoutGuard: CanActivateFn = (route, state) => {
  let _router =inject(Router);
  let platformId = inject(PLATFORM_ID);

  if (isPlatformBrowser(platformId)){
    let token =  sessionStorage.getItem("token");
    // console.log('token',token);
  
     if(token){
      _router.navigate(['/home']) ;
      return false;
   }else{
    return true;
  }
}else{
  return true;
}
};
